let deleteActionMixin = {
    methods: {
        deleteAction (message, title='Delete Action') {
            return this.$swal({
                type: 'warning',
                title: title,
                text: message ? message : `Are you sure you want to delete this action?`,
                showCancelButton: true,
                confirmButtonText: 'Yes, continue!',
                cancelButtonText: 'No, cancel!',
            }).then((result) => {
                if (result.value) {
                    this.deleteItem();
                }
            });
        }
    }
};

export default deleteActionMixin;
